module.exports = __webpack_public_path__ + "static/media/menu-integrations.057459e1.svg";